import ActiveRecord from './base/ActiveRecord';

class Service extends ActiveRecord {

    constructor(name) {
        super(name);
        this.form = {
            name: '',
            product_id: ''
        };
    }
}

export default Service;
